document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.texture-universal [data-accordion-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrapper = btn.closest('[data-accordion]');
      var drawer = document.getElementById(btn.getAttribute('aria-controls'));
      var isOpen = wrapper.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(isOpen));
      if (drawer) drawer.setAttribute('aria-hidden', String(!isOpen));
    });
  });

  document.querySelectorAll('.texture-universal__collage').forEach(function (collage) {
    var img = collage.querySelector('img');
    if (!img) return;

    collage.addEventListener('mousemove', function (event) {
      var rect = collage.getBoundingClientRect();
      var x = (event.clientX - rect.left) / rect.width - 0.5;
      var y = (event.clientY - rect.top) / rect.height - 0.5;
      img.style.setProperty('--tilt-y', (x * 6).toFixed(2) + 'deg');
      img.style.setProperty('--tilt-x', (y * -6).toFixed(2) + 'deg');
      img.style.setProperty('--tilt-scale', '1.03');
    });

    collage.addEventListener('mouseleave', function () {
      img.style.setProperty('--tilt-x', '0deg');
      img.style.setProperty('--tilt-y', '0deg');
      img.style.setProperty('--tilt-scale', '1');
    });
  });
});
